import { ResourceState, useScopedSelector } from 'ia-react-core';
import { useCallback, useEffect, useRef } from 'react';

export type UseWaitUntilResourceOptions = {
  name: string;
};

const useWaitUntilResource = ({ name }: UseWaitUntilResourceOptions) => {
  const resolveRef = useRef<() => void>();

  const resourceState: ResourceState = useScopedSelector(name);
  const data = useScopedSelector((resourceState?.dataDst as string) || '');

  const waitUntilResource = useCallback<() => Promise<void>>(() => (
    new Promise<void>((resolve) => {
      resolveRef.current = resolve;
    })
  ), []);

  useEffect(() => {
    if (data && resourceState?.pending === false) {
      // Give some time to Helmet to render the title
      setTimeout(() => {
        resolveRef.current();
      }, 100);
    }
  }, [data, resourceState?.pending]);

  return waitUntilResource;
};

export default useWaitUntilResource;
